<template>
  <div>
    <TriangleAlert v-if="isFreigegeben && isBetragChanged" :size="20" style="color: #ffa800"></TriangleAlert>
    <FileCheck v-else-if="isFreigegeben" :size="20" style="color: #28a745" />
    <div
      v-else-if="isFreigabeZurueckgenommen"
      v-b-tooltip.hover.html="{ title: freigabeZurueckgenommenTooltip, customClass: 'tooltip-class' }"
    >
      <RotateCcw :size="20" style="color: #000000" />
    </div>
    <CircleX v-else-if="isStorno" :size="20" style="color: #dc3545" />
    <Ban v-else-if="isTeilstorno" :size="20" style="color: #dc3545"></Ban>
    <TriangleAlert v-else-if="isBetragChanged" :size="20" style="color: #ffa800"></TriangleAlert>
  </div>
</template>

<script>
import { CircleX, FileCheck, TriangleAlert, Ban, RotateCcw } from 'lucide-vue';
import { formatDateWithoutHours, parseFullUsername } from '@/core/common/helpers/utils';

export default {
  name: 'CellRendererRepruStatus',
  components: {
    CircleX,
    FileCheck,
    TriangleAlert,
    Ban,
    RotateCcw,
  },
  computed: {
    // AG Grid injiziert params als data, die b-table uebergibt sie als Attribut
    cellParams() {
      return this.params ?? this.$attrs.params;
    },

    isStorno() {
      return this.cellParams?.data?.leistungstyp === 'Storno' || false;
    },

    isTeilstorno() {
      return this.cellParams?.data?.leistungstyp === 'Teilstorno' || false;
    },

    isFreigegeben() {
      return this.cellParams?.data?.isFreigegeben || false;
    },

    isFreigabeZurueckgenommen() {
      return (
        this.cellParams?.data?.freigabeZurueckgenommenDurch &&
        this.cellParams?.data?.freigabeZurueckgenommenAm
      );
    },

    freigabeZurueckgenommenTooltip() {
      const formattedDatum = formatDateWithoutHours(this.cellParams?.data?.freigabeZurueckgenommenAm);
      const users = this.$store.state.users['users'] || [];
      const user = users.find(u => u.id === this.cellParams?.data?.freigabeZurueckgenommenDurch);
      const userName = user ? parseFullUsername(user) : '-';
      return `Freigabe zurückgenommen am ${formattedDatum} von ${userName}`;
    },

    isBetragChanged() {
      if (this.cellParams?.data?.freigabebetrag === 0.0) {
        return false;
      }

      return this.cellParams?.data?.betrag !== this.cellParams?.data?.freigabebetrag;
    },
  },
};
</script>

<style>
.tooltip-class.tooltip {
  opacity: 1;
}
.tooltip-class .tooltip-inner {
  max-width: none;
}
</style>
